import styled from 'styled-components';
export const EmptyStateContainer = styled.div `
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;
